import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

export interface UserIsPendingResponse {
    pending: boolean;
}

export const userIsPending = async () => {
    const { data } = await axios.get<UserIsPendingResponse>(pathfinder('user_is_pending'));
    return !!data.pending;
};
